export class ArrayUtil {
    private static instance: ArrayUtil;

    static getInstance() {
        if (!ArrayUtil.instance) {
            ArrayUtil.instance = new ArrayUtil();
        }

        return ArrayUtil.instance;
    }

    /**
    * ArrayUtil is a singleton class, so use ArrayUtil.getInstance() method instead of creating new ArrayUtil().
    */
    private constructor() {

    }

    sort(list: Array<any>, field: string): Array<any> {
        if (list.length <= 1) return list;
        return list.sort(function (a: any, b: any) { return a[field] - b[field]; });
    }

    sortBySrt_Order(list: Array<any>): Array<any> {
        if (list.length <= 1) return list;
        return list.sort(function (a: any, b: any) { return a.srt_Order - b.srt_Order; });
    }

    copy(arrayTmp: Array<any>): Array<any> {
        let array: Array<any> = new Array<any>();

        for (let i: number = 0; i < arrayTmp.length; i++) {
            array.push(arrayTmp[i]);
        }

        return array;
    }

    copyFrom(array: Array<any>, arrayTmp: Array<any>): void {
        array.splice(0, array.length);

        for (let i: number = 0; i < arrayTmp.length; i++) {
            array.push(arrayTmp[i]);
        }
    }

    compare(array: Array<any>, arrayTmp: Array<any>): string {
        let arrayLength = array.length;
        let arrayTmpLength = arrayTmp.length;

        if (arrayLength != arrayTmpLength) {
            return 'list length is different.';
        }

        for (let i: number = 0; i < arrayLength; i++) {
            if (array[i] != arrayTmp[i]) {
                return 'list [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(array: Array<any>): string {
        let str: string = ''

        if (array.length > 0) {
            str += array[0];

            for (let i: number = 1; i < array.length; i++) {
                str += ', ' + array[i];
            }
        }

        return str;
    }
}
